module.exports = __webpack_public_path__ + "static/media/20201129_195749_096_IMG_1758.6e32f04b.jpg";